import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useForm } from 'react-hook-form';
import InputEn from '../../components/InputEn';
import { Button } from '../../components/ui/button';
import { FileUpload } from '../../components/InputImage';
import Input from '../../components/ui/input';
import useTestimonial from '../../stores/useTestimonial';
import { ITestimonial } from '../../types/types';

export default function FormTesti() {
  const { saveLoading, testimonials, fetchTestimonials, addTestimonial, editTestimonial } = useTestimonial();
  const [searchParams, setSearchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  const [currentImage, setCurrentImage] = useState<string>('/assets/no-data-image.svg');
  const [fileUploadKey, setFileUploadKey] = useState(0);
  const { register, handleSubmit, setValue, reset, watch } = useForm<ITestimonial>({
    defaultValues: {
      name_testi: '',
      message_testi_id: '',
      message_testi_en: '',
      photo_testi: '',
    },
  });

  useEffect(() => {
    fetchTestimonials();
  }, [fetchTestimonials]);

  useEffect(() => {
    if (editId) {
      const testimonialToEdit = testimonials?.find((testimonial) => testimonial.testimoni_id === Number(editId));
      if (testimonialToEdit) {
        setValue('name_testi', testimonialToEdit.name_testi);
        setValue('message_testi_id', testimonialToEdit.message_testi_id);
        setValue('message_testi_en', testimonialToEdit.message_testi_en);
        setValue('photo_testi', testimonialToEdit.photo_testi);
        setCurrentImage(testimonialToEdit.photo_testi || '/assets/no-data-image.svg');
      }
    }
  }, [editId, testimonials, setValue]);

  const onSubmit = async (data: ITestimonial) => {
    if (editId) {
      await editTestimonial(Number(editId), data);
      setSearchParams();
    } else {
      await addTestimonial(data);
    }
    reset();
    setCurrentImage('/assets/no-data-image.svg');
    setFileUploadKey((prevKey) => prevKey + 1);
  };

  const handleCancel = () => {
    setSearchParams();
    reset();
    setCurrentImage('/assets/no-data-image.svg');
  };

  return (
    <div className="flex gap-4 w-full flex-col overflow-hidden">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-3">
          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Name <span className="text-red-600">*</span>
            </p>
            <Input {...register('name_testi')} required type="text" placeholder="Nama pengirim..." />
          </div>

          <div className="flex flex-col text-sm gap-2">
            <p className="flex gap-1">
              Message <span className="text-red-600">*</span>
            </p>
            <InputEn
              type="textarea"
              nama="message_testi_id"
              namaEn="message_testi_en"
              placeholder="Masukkan pesan testimoni..."
              register={register}
              watch={watch}
              setValue={setValue}
            />
          </div>

          <div className="flex flex-col text-sm w-full mt-2 gap-2">
            <p className="flex gap-1">
              Photo <span className="text-red-600">*</span>
            </p>
            <FileUpload
              key={fileUploadKey}
              setValue={setValue}
              register={register}
              imageFieldName="photo_testi"
              defaultImage={currentImage}
            />
          </div>
          <div className="flex gap-2 items-center">
            {editId && (
              <Button type="button" onClick={handleCancel} variant="secondary">
                Batal
              </Button>
            )}
            <Button type="submit" disabled={saveLoading}>
              {saveLoading ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
